import { Component } from '@angular/core';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { PageVisitService } from './services/page-visit.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Praxis App';

  constructor(
    private googleAnalytics: GoogleAnalyticsService,
    private pageVisitService: PageVisitService
  ) {
    this.googleAnalytics.init();
    this.pageVisitService.init();
  }
}
